import { Navigate, useLocation, useParams } from 'react-router-dom'

/**
 * /schede-lavoro/:id/nuova → /schede-lavoro/:id
 *
 * Dal 04/09/2026 la V3 e' la pagina predefinita e vive su /schede-lavoro/:id.
 * La vecchia rotta di collaudo resta in vita perche' e' in giro da giorni:
 * qualcuno l'ha nei segnalibri, e il tab "Lavori in officina" ci puntava.
 *
 * `replace` perche' non deve restare nella cronologia: premendo indietro si
 * tornerebbe qui e si verrebbe rispediti avanti, in un rimbalzo senza uscita.
 * La querystring viaggia con il reindirizzamento: puo' contenere il contesto
 * da cui si e' arrivati.
 */
export default function RedirectDettaglioNuova() {
  const { id } = useParams<{ id: string }>()
  const { search, hash } = useLocation()
  return <Navigate to={`/schede-lavoro/${id}${search}${hash}`} replace />
}
